import styled from 'styled-components';
import { Row } from 'react-bootstrap';

export const OrgCardsContainer = styled(Row)`
  height: calc(100vh - 250px);
  padding: 20px 0;
`;

export const AdminHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0;
`;

export const SearchSection = styled.div`
  display: flex;
  flex: 1;
  gap: 1rem;
  align-items: center;
  min-width: 300px;
`;

export const FilterButton = styled.button`
  min-width: 120px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border: 1px solid #1a1a2e;
  color: #1a1a2e;
  background: transparent;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 16px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: #1a1a2e;
    color: #f4f1de;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(26, 26, 46, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;